import { Component, OnInit, Output, Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { NgIf } from '@angular/common';
import { NgClickOutsideDirective } from 'ng-click-outside2';

@Component({
    selector: 'app-item-success',
    templateUrl: './item-success.component.html',
    styleUrls: ['./item-success.component.scss'],
    standalone: true,
    imports: [NgClickOutsideDirective, NgIf]
})
export class ItemSuccessComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Input() sucessMsg: string;
  /** Heading copy. Defaults to the edit-flow wording so existing callers are
   *  unchanged; the Create flow passes "Item Created". */
  @Input() title = 'Successful Update';
  /** Optional secondary line under the message: a non-blocking advisory about the
   *  write that just succeeded (the HUBX-8429 category notice is the first one).
   *  Defaults to empty and then renders nothing, so every existing caller is
   *  untouched — the same additive pattern as `title`. */
  @Input() note = '';
  constructor() { }

  ngOnInit() {}

}
